import type React from 'react'

import { Keep } from '@frontend/components/icons/outline'
import SearchButton from '@frontend/features/search-bar/SearchButton'
import useSiteConfiguration from '@frontend/libs/hooks/useSiteConfiguration'
import { generateUuidList } from '@frontend/libs/utils'
import logo from '@images/logo.png'
import { Button, ButtonGroup, cn, Image, Skeleton } from '@nextui-org/react'
import { Link } from 'react-router-dom'

import SignInButton from '../authentication/SignInButton'
import MiniCartButton from '../shop/cart/MiniCartButton'
import MegaMenu from './components/mega-menu/MegaMenu'
import { useScrollHandler } from './lib/hook'

const LoaderMenu: React.FC = () => (
  <div className="flex justify-center gap-4">
    {generateUuidList(6).map((item) => (
      <Skeleton className="h-5 w-28" key={item}>
        <span className="h-5 w-28 bg-default-300" />
      </Skeleton>
    ))}
  </div>
)

function NavigationDesktop() {
  const { isLoading, menus, settings, siteInfo } = useSiteConfiguration()
  const { headerVisible, isTop } = useScrollHandler()

  return (
    <header
      className={cn(
        'w-full border-b bg-white py-8 shadow-sm transition-all delay-100 duration-300 ease-in-out',
        {
          '-translate-y-full transform': !headerVisible,
          'sticky left-0 top-0 z-50': !isTop,
        },
      )}
    >
      <div className="container grid grid-cols-3 items-center pb-16 pt-10">
        <div />
        <Link to={siteInfo?.url || '/'}>
          <Image
            alt="Logo"
            classNames={{
              img: 'w-[270px]',
              wrapper: 'mx-auto',
            }}
            src={settings?.logo || logo}
          />
        </Link>
        <ButtonGroup
          className="justify-end gap-2 [&>*]:w-auto [&>*]:min-w-0 [&>*]:p-0"
          variant="light"
        >
          <SignInButton />
          <MiniCartButton />
          <Button as={Link} isIconOnly to="/wishlist">
            <Keep className="block h-10 w-10 !max-w-none text-transparent" />
          </Button>
          <SearchButton />
        </ButtonGroup>
      </div>
      {isLoading && <LoaderMenu />}
      {!isLoading && (
        <nav className="main-navigation">
          <ul className="flex justify-center space-x-8">
            {menus?.primary?.map((menu) => {
              if (menu.description) {
                return <MegaMenu key={menu.id} menu={menu} />
              }
              return (
                <li className="menu-item font-medium uppercase" key={menu.id}>
                  <Link
                    className="menu-item"
                    color="primary"
                    target={menu.target}
                    title={menu.title}
                    to={menu.url}
                  >
                    {menu.title}
                  </Link>
                </li>
              )
            })}
          </ul>
        </nav>
      )}
    </header>
  )
}

export default NavigationDesktop
